import React, { useEffect } from "react";

export function AdSense({
    client,
    slot,
    format = "auto",
    style = { display: "block" },
    responsive = "true",
    className = "adsbygoogle",
    layout = "",
    contentUiType,
    contentRows,
    contentColumns,
    children,
}) {
    useEffect(() => {
        if (window) (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, []);
    return (
        <ins
            className={className}
            style={style}
            data-ad-client={client}
            data-ad-slot={slot}
            data-ad-format={format}
            data-ad-layout={layout}
            data-full-width-responsive={responsive}
            data-matched-content-ui-type={contentUiType}
            data-matched-content-rows-num={contentRows}
            data-matched-content-columns-num={contentColumns}
        >
            {children}
        </ins>
    );
}